import { FormControl } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { GDPRService } from 'src/app/core/services/rulebook';
import { FileType } from './../../../core/enums/user/file-type';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { SessionService } from './../../../core/services/auth/session.service';
import { ToastViewModel } from './../../../core/models/view-model/toast-view-model';
import { SelfAssessment } from 'src/app/core/models/self-assessment/self-assessment';
import { AnalyticsService } from './../../../core/services/analytics/analytics.service';
import { VersionFilterViewModel } from 'src/app/core/models/self-assessment/version-filter-view-model';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { SelfAssessmentDialogComponent } from '../self-assessment-dialog/self-assessment-dialog.component';
import {
  SelfAssessmentAllDropdownList,
  SelfAssessmentDetailsDD,
} from './../../../core/models/self-assessment/self-assessment-details-dd';
import { UpdateSelfAssessmentModel } from 'src/app/core/models/self-assessment/update-self-assessment-model';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { SelfAssessmentDetailHistory } from './../../../core/models/self-assessment/self-assessment-detail-history';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { Role } from 'src/app/core/models/user-management/role';
import { FilterViewModelForOwner } from 'src/app/core/models/regulation/filter-view.model';
import { RegulationService } from 'src/app/core/services/regulation';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//  import * as customBuild from './../../../build/ckeditor';
//import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';
import { SelfAssessmentVersionModel } from 'src/app/core/models/self-assessment/self-assessment-version-model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { ChangeDetailComponent } from '../../change-detail/change-detail.component';

@Component({
  selector: 'app-assessment-details',
  templateUrl: './assessment-details.component.html',
  styleUrls: ['./assessment-details.component.scss'],
})
export class AssessmentDetailsComponent implements OnInit {
  selfAssessment: SelfAssessment;
  selfAssessmentDD: SelfAssessmentDetailsDD;
  selfAssessmentDocument: Array<SelfAssessmentDocumentModel>;
  updateSADetails: UpdateSelfAssessmentModel;
  effectiveDate: string;
  // selfAssessmentId: number;
  // filterType: string;
  isLoading = false;
  isToastShow = false;
  toastModel: ToastViewModel;
  libraryMenu: Array<MenuItemModel>;
  isAssessmentLoader = false;
  isReviewLoader = false;
  isLoadingDD = false;
  formattedDesc: string;
  isSaved = false;
  isAssessmentLastEdited = false;
  isReviewLastEdited = false;
  isGapActionLastEdited = false;
  isEnhancementLastEdited = false;
  isOverallLastEdited = false;
  saDetailHistory: SelfAssessmentDetailHistory;

  assessorDD: string[] = [];
  assessorDelDD: string[] = [];
  reviewerDD: string[] = [];
  reviewerDelDD: string[] = [];
  actOwnerDD: string[] = [];
  enhmtActOwnerDD: string[] = [];

  searchedAssessor: FilterViewModel[] = [];
  searchedAssessorDel: FilterViewModel[] = [];
  searchedReviewer: FilterViewModel[] = [];
  searchedReviewerDel: FilterViewModel[] = [];
  searchedActOwner: FilterViewModel[] = [];
  searchedEnhmtActOwner: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchAssessorCntrl: FormControl = new FormControl();
  searchAssessorDelCntrl: FormControl = new FormControl();
  searchReviewerCntrl: FormControl = new FormControl();
  searchReviewerDelCntrl: FormControl = new FormControl();
  searchActOwnerCntrl: FormControl = new FormControl();
  searchEnhmtActOwnerCntrl: FormControl = new FormControl();

  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;

  @ViewChild('assessorDelInput')
  assessorDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorDelAutocomplete')
  assessorDelAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerInput')
  reviewerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerAutocomplete')
  reviewerAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerDelInput')
  reviewerDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerDelAutocomplete')
  reviewerDelAutocomplete!: MatAutocomplete;

  @ViewChild('actOwnerInput')
  actOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('actOwnerAutocomplete')
  actOwnerAutocomplete!: MatAutocomplete;

  @ViewChild('enhmtActOwnerInput')
  enhmtActOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('enhmtActOwnerAutocomplete')
  enhmtActOwnerAutocomplete!: MatAutocomplete;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  isVersioned = false;

  ruleApplicable: Array<string> = ['Yes', 'No'];
  // assessmentStatus: Array<string> = [
  //   'Not Started',
  //   'In Progress',
  //   'Ready for Review',
  //   'Under Review',
  //   'Agreed with Reviewer - Final',
  //   'In Escalation',
  //   'Complete - Final',
  // ];
  // reviewStatus: Array<string> = [
  //   'Not Started',
  //   'In Progress',
  //   'Completed - Subject to Assessor Review',
  //   'Agreed with Assessor - Final',
  // ];
  // overallStatus: Array<string> = [
  //   'On Track',
  //   'Overdue',
  //   'Complete',
  //   'Not Applicable',
  // ];
  // ruleConclusion: Array<string> = [
  //   'Fully Compliant',
  //   'Area of Enhancement',
  //   'Compliance Gap',
  //   'Not Applicable',
  // ];
  // gapReviewStatus: Array<string> = ['Gap Confirmed', 'Reassessed - No Gap'];
  // actionStatus: Array<string> = ['Open', 'On Track', 'Overdue', 'Complete'];
  // enhancementReviewStatus: Array<string> = [
  //   'Enhancement Confirmed',
  //   'Reassessed - No Enhancement',
  // ];
  // enhancementActionStatus: Array<string> = [
  //   'Open',
  //   'On Track',
  //   'Overdue',
  //   'Complete',
  // ];
  assessmentStatus: Array<string> = [];
  reviewStatus: Array<string> = [];
  overallStatus: Array<string> = [];
  ruleConclusion: Array<string> = [];
  gapReviewStatus: Array<string> = [];
  actionStatus: Array<string> = [];
  enhancementReviewStatus: Array<string> = [];
  enhancementActionStatus: Array<string> = [];
  currentUserRole = '';
  user: UserProfile;
  isSADetails1 = false;
  isSADetails2 = false;
  isSADetails3 = false;
  isSADetails4 = false;
  isSADetails5 = false;
  isSADetails6 = false;
  isSADetails7 = false;
  isSADetails8 = false;
  //For Owner
  ownerDD: string[] = [];
  @ViewChild('ownerAutocomplete')
  ownerAutocomplete!: any;
  @ViewChild('trigautoOwner')
  trigautoOwner!: MatAutocompleteTrigger;
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;
  allSearchedOwner: FilterViewModelForOwner[] = [];
  searchOwnerCntrl: FormControl = new FormControl();
  changeFields: Array<string> = [];
  versionNo: number = 0;

  //public Editor = customBuild;
  selfAssessmentAllDropdownList: SelfAssessmentAllDropdownList;
  @Input()
  selfAssessmentId!: number;
  @Input()
  filterType!: string;
  divisionId!: number;
  templateNo: number = 1;
  idList: number[]=[];

  constructor(
    private gdprService: GDPRService,
    public dialog: MatDialog,
    private sessionService: SessionService,
    private regulationService: RegulationService,
    private analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private generalService: GeneralDataService,
    private router: Router
  ) {
    this.selfAssessment = new SelfAssessment();
    this.selfAssessmentDD = new SelfAssessmentDetailsDD();
    this.updateSADetails = new UpdateSelfAssessmentModel();

    this.effectiveDate = '';
    this.toastModel = new ToastViewModel();
    this.libraryMenu = [];
    this.selfAssessmentDocument = [];
    this.formattedDesc = '';
    this.saDetailHistory = new SelfAssessmentDetailHistory();
    this.user = new UserProfile();
    this.selfAssessmentAllDropdownList = new SelfAssessmentAllDropdownList();
    this.route.paramMap.subscribe(params => {
      const state = window.history.state;
      if (state && state.idList) {
        this.idList = state.idList;
      } else {
        this.idList = [];
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    if (!this.selfAssessmentId) {
      this.selfAssessmentId = Number(this.route.snapshot.params['id']);
      this.filterType = this.route.snapshot.params['filter'];
    }
    this.getUserMenu();
    await this.getUserProfile();
    this.gdprService.getSelfAssessmentTemplate(this.user.lastUsedJurisdictionId).subscribe((templateNo: number) => {
      this.templateNo = templateNo;
      if (templateNo == 1) {
        if (this.filterType === 'self') {
          this.saDetailHistory = new SelfAssessmentDetailHistory();
          this.fetchSelfAssessmentDetails();
          this.fetchSADetailsHistory();
          this.fetchSelfAssessmentDD();
          this.getOwnerDD();
          this.fetchSelfAssessmentAllDropdownList();
        } else {
          this.fetchSelfAssessmentVersionHistoryDetails();
        }
      }
    });

    this.generalService.getDivisionSelected().subscribe(async res => {
      const currentPath = window.location.pathname;
      if (currentPath.includes('/self-assessment/details/self/')) {
        this.router.navigate(['/self-assessment/summary/']);
      }

    })
  }
  get searchedOwner(): FilterViewModelForOwner[] {
    if (this.searchOwnerCntrl.value != null) {
      const filterValue = this.searchOwnerCntrl.value.toLowerCase();
      return this.allSearchedOwner.filter((obj) =>
        obj.name.toLowerCase().includes(filterValue)
      );
    }
    return this.allSearchedOwner;
  }

  async getUserProfile() {
    const userDetails: UserProfile = await this.sessionService.getLoginUserInfo().toPromise();
    this.user = userDetails;
    if (this.user && this.user.roleId > 0) {
      this.fetchCurrentUserRole();
    }
    // await this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
    //   this.user = user;
    //   // this.user.externalUserId
    //   if (this.user && this.user.roleId > 0) {
    //     this.fetchCurrentUserRole();
    //   }
    // });
  }

  fetchCurrentUserRole(): void {
    this.gdprService
      .getCurrentUserRole(this.user.roleId)
      .subscribe((data: Role) => {
        this.currentUserRole = data.title;
      });
  }

  fetchSelfAssessmentDetails(): void {
    this.isLoading = true;
    this.gdprService
      .getSelfAssessmentDetails(this.selfAssessmentId)
      .subscribe((result: SelfAssessment) => {
        this.effectiveDate = this.dateFormat(result.effectiveDate);
        this.selfAssessment = result;
        // this.ownerDD = this.selfAssessment.owner
        //   ? this.selfAssessment.owner.split(',')
        //   : this.ownerDD;
        this.ownerDD = this.selfAssessment.owner
          ? this.selfAssessment.owner.split('|')
          : this.ownerDD;
        this.isLoading = false;
        this.fetchFormattedDesc();
        this.getAssessmentDocuments();
      });
  }
  fetchSelfAssessmentVersionHistoryDetails(): void {
    this.isLoading = true;
    this.gdprService
      .getSelfAssessmentVersionDetails(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentVersionModel) => {
        this.effectiveDate = this.dateFormat(
          result.selfAssessData.effectiveDate
        );
        this.selfAssessment = result.selfAssessData;
        this.isVersioned = true;
        this.changeFields = result.changedFields;
        this.versionNo = this.selfAssessment.versionNumber;
        // this.ownerDD = this.selfAssessment.owner
        //   ? this.selfAssessment.owner.split(',')
        //   : this.ownerDD;
        this.ownerDD = this.selfAssessment.owner
          ? this.selfAssessment.owner.split('|')
          : this.ownerDD;
        this.isLoading = false;
        this.selectedDDvalue();
        this.fetchFormattedDesc();
        this.getAssessmentDocuments();
      });
  }

  fetchSelfAssessmentDD(): void {
    this.isLoadingDD = true;
    this.gdprService
      .getSelfAssessmentDD()
      .subscribe((result: SelfAssessmentDetailsDD) => {
        this.isLoadingDD = false;
        this.selfAssessmentDD = result;
        this.ddListData();
        this.selectedDDvalue();
      });
  }

  fetchSADetailsHistory(): void {
    this.gdprService
      .GetSADetailsHistory(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentDetailHistory) => {
        this.saDetailHistory = result;
      });
  }

  getAssessmentDocuments(): void {
    this.isAssessmentLoader = true;
    this.isReviewLoader = true;
    this.gdprService
      .getSelfAssessmentDocuments(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        this.isAssessmentLoader = false;
        this.isReviewLoader = false;
      });
  }

  ddListData(): void {
    this.searchedAssessor = this.selfAssessmentDD.assessor;
    this.searchedAssessorDel = this.selfAssessmentDD.assessorDelegate;
    this.searchedReviewer = this.selfAssessmentDD.reviewer;
    this.searchedReviewerDel = this.selfAssessmentDD.reviewerDelegate;
    this.searchedActOwner = this.selfAssessmentDD.actionOwner;
    this.searchedEnhmtActOwner = this.selfAssessmentDD.enhancementActionOwner;
    this.searchAssessorCntrl.valueChanges.subscribe((data: any) => {
      this.searchedAssessor = data
        ? this.filterAssessor(data)
        : this.selfAssessmentDD.assessor;
    });
    this.searchAssessorDelCntrl.valueChanges.subscribe((data: any) => {
      this.searchedAssessorDel = data
        ? this.filterAssessorDelegate(data)
        : this.selfAssessmentDD.assessorDelegate;
    });
    this.searchReviewerCntrl.valueChanges.subscribe((data: any) => {
      this.searchedReviewer = data
        ? this.filterReviewer(data)
        : this.selfAssessmentDD.reviewer;
    });
    this.searchReviewerDelCntrl.valueChanges.subscribe((data: any) => {
      this.searchedReviewerDel = data
        ? this.filterReviewerDelegate(data)
        : this.selfAssessmentDD.reviewerDelegate;
    });
    this.searchActOwnerCntrl.valueChanges.subscribe((data: any) => {
      this.searchedActOwner = data
        ? this.filterActionOwner(data)
        : this.selfAssessmentDD.actionOwner;
    });
    this.searchEnhmtActOwnerCntrl.valueChanges.subscribe((data: any) => {
      this.searchedEnhmtActOwner = data
        ? this.filterEnhmtActionOwner(data)
        : this.selfAssessmentDD.enhancementActionOwner;
    });
  }

  selectedDDvalue(): void {
    this.assessorDD = this.selfAssessment.assessor
      ? this.selfAssessment.assessor.split(',')
      : this.assessorDD;
    this.assessorDelDD = this.selfAssessment.assessorDelegate
      ? this.selfAssessment.assessorDelegate.split(',')
      : this.assessorDelDD;
    this.reviewerDD = this.selfAssessment.reviewer
      ? this.selfAssessment.reviewer.split(',')
      : this.reviewerDD;
    this.reviewerDelDD = this.selfAssessment.reviewerDelegate
      ? this.selfAssessment.reviewerDelegate.split(',')
      : this.reviewerDelDD;
    this.actOwnerDD = this.selfAssessment.actionOwner
      ? this.selfAssessment.actionOwner.split(',')
      : this.actOwnerDD;
    this.enhmtActOwnerDD = this.selfAssessment.enhancementActionOwner
      ? this.selfAssessment.enhancementActionOwner.split(',')
      : this.enhmtActOwnerDD;
  }

  updateSelfAssessment(): void {
    this.isSaved = true;
    this.isLoading = true;
    if (this.isAssessmentLastEdited) {
      this.selfAssessment.assessmentLastEdited = MasterHelper.getDate(0);
    }
    if (this.isReviewLastEdited) {
      this.selfAssessment.reviewLastEdited = MasterHelper.getDate(0);
    }
    if (this.isGapActionLastEdited) {
      this.selfAssessment.actionLastEdited = MasterHelper.getDate(0);
    }
    if (this.isEnhancementLastEdited) {
      this.selfAssessment.enhancementActionLastEdited = MasterHelper.getDate(0);
    }
    this.selfAssessment.assessor = this.assessorDD.toString();
    this.selfAssessment.assessorDelegate = this.assessorDelDD.toString();
    this.selfAssessment.reviewer = this.reviewerDD.toString();
    this.selfAssessment.reviewerDelegate = this.reviewerDelDD.toString();
    this.selfAssessment.actionOwner = this.actOwnerDD.toString();
    this.selfAssessment.enhancementActionOwner = this.actOwnerDD.toString();
    // this.selfAssessment.referenceDate = MasterHelper.bsdatePickerToCorrectDate(this.selfAssessment.referenceDate.toString());
    this.selfAssessment.assessmentLastEdited = this.selfAssessment
      .assessmentLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.assessmentLastEdited.toString()
      )
      : null;
    this.selfAssessment.assessmentDueDate = this.selfAssessment
      .assessmentDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.assessmentDueDate.toString()
      )
      : null;
    this.selfAssessment.reviewLastEdited = this.selfAssessment.reviewLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.reviewLastEdited.toString()
      )
      : null;
    this.selfAssessment.reviewDueDate = this.selfAssessment.reviewDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.reviewDueDate.toString()
      )
      : null;
    this.selfAssessment.actionLastEdited = this.selfAssessment.actionLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.actionLastEdited.toString()
      )
      : null;
    this.selfAssessment.actionDueDate = this.selfAssessment.actionDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.actionDueDate.toString()
      )
      : null;
    this.selfAssessment.enhancementActionLastEdited = this.selfAssessment
      .enhancementActionLastEdited
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.enhancementActionLastEdited.toString()
      )
      : null;
    this.selfAssessment.enhancementActionDueDate = this.selfAssessment
      .enhancementActionDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.selfAssessment.enhancementActionDueDate.toString()
      )
      : null;
    const currentUrl = window.location.href;
    this.updateSADetails.selfAssessmentDetails = this.selfAssessment;
    this.gdprService
      .updateSelfAssessment(this.updateSADetails, currentUrl)
      .subscribe((result: SelfAssessment) => {
        this.isLoading = false;
        this.selfAssessment = result;
        this.alertMessage('success', 'Successfully updated');
        this.isSaved = false;
        this.updateSADetails = new UpdateSelfAssessmentModel();
        this.fetchSADetailsHistory();
        this.isSADetails1 = false;
        this.isSADetails2 = false;
        this.isSADetails3 = false;
        this.isSADetails4 = false;
        this.isSADetails5 = false;
        this.isSADetails6 = false;
        this.isSADetails7 = false;
        this.isSADetails8 = false;
      });
  }

  fetchFormattedDesc(): void {
    let desc = '';
    if (this.selfAssessment.title1) {
      desc = desc + this.selfAssessment.title1.trim() + '|';
    }
    if (this.selfAssessment.title2) {
      desc = desc + this.selfAssessment.title2.trim() + '|';
    }
    if (this.selfAssessment.title3) {
      desc = desc + this.selfAssessment.title3.trim() + '|';
    }
    if (this.selfAssessment.title4) {
      desc = desc + this.selfAssessment.title4.trim() + '|';
    }
    if (this.selfAssessment.ruleID) {
      desc = desc + this.selfAssessment.ruleID.trim() + '|';
    }
    if (this.selfAssessment.regulatoryRuleFullRequirement) {
      desc = desc + this.selfAssessment.regulatoryRuleFullRequirement.trim();
    }
    this.formattedDesc = desc ? desc.split('|').join('\n') : '';
  }

  openDialog(): void {
    const filterDataModel = new VersionFilterViewModel();
    filterDataModel.selfAssessment = this.selfAssessment;
    filterDataModel.versionId = this.selfAssessmentId;
    filterDataModel.filterType = this.filterType;
    filterDataModel.templateId = this.templateNo;
    const dialogRef = this.dialog.open(SelfAssessmentDialogComponent, {
      data: filterDataModel,
      width: '750px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  dateFormat(effectiveDate: string): any {
    const eDate = effectiveDate
      ? effectiveDate.split('|')[0]
      : MasterHelper.getDateStr(0);
    return MasterHelper.formatDate(eDate, 'YYYY-MM-DD');
  }

  getUserMenu(): void {
    this.analyticsService
      .getLibraryMenu()
      .subscribe((data: MenuItemModel[]) => {
        this.libraryMenu = data;
      });
  }

  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(
      (a) => a.screenName === currentUrl && a.parentId != null
    )
      ? true
      : false;
  }

  fetchSelfAssessmentDocuments(fileType: FileType): void {
    if (fileType === FileType.Assessment) {
      this.isAssessmentLoader = true;
    } else {
      this.isReviewLoader = true;
    }
    this.gdprService
      .getSelfAssessmentDocuments(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        if (fileType === FileType.Assessment) {
          this.isAssessmentLoader = false;
        } else {
          this.isReviewLoader = false;
        }
      });
  }

  openDeleteModel(id: number, fileType: string): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.removeSelfAssessmentDocuments(id, fileType);
      }
    });
  }

  removeSelfAssessmentDocuments(id: number, fileType: string): void {
    if (fileType === 'Assessment') {
      this.isAssessmentLoader = true;
    } else {
      this.isReviewLoader = true;
    }
    this.gdprService.deleteSelfAssessmentDocument(id).subscribe((data: any) => {
      if (fileType === 'Assessment') {
        this.isAssessmentLoader = false;
        this.fetchSelfAssessmentDocuments(FileType.Assessment);
      } else {
        this.isReviewLoader = false;
        this.fetchSelfAssessmentDocuments(FileType.Review);
      }
      if (data.result) {
        this.alertMessage('success', data.result);
      }
    });
  }

  uploadEvidenceAssessment(): void {
    const fileInput = document.getElementById(
      'uploadEviAssessment'
    ) as HTMLElement;
    fileInput.click();
  }

  handleFileInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.Assessment);
    }
  }

  uploadEvidenceReview(): void {
    const fileInput = document.getElementById('uploadEviReview') as HTMLElement;
    fileInput.click();
  }

  handleReviewInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.Review);
    }
  }

  uploadFileToActivity(fileToUpload: any, fileType: FileType): void {
    if (fileType === FileType.Assessment) {
      this.isAssessmentLoader = true;
    } else {
      this.isReviewLoader = true;
    }
    this.gdprService
      .uploadEvidence(fileToUpload, fileType, this.selfAssessmentId)
      .subscribe(
        (data: any) => {
          this.fetchSelfAssessmentDocuments(fileType);
          if (fileType === FileType.Assessment) {
            this.isAssessmentLoader = false;
            this.updateSectionLastEdited('Assessment');
          } else {
            this.isReviewLoader = false;
            this.updateSectionLastEdited('Review');
          }
        },
        (err: HttpErrorResponse) => {
          this.isAssessmentLoader = false;
          this.isReviewLoader = false;
          this.alertMessage(
            'warning',
            'File not uploaded, please check your file'
          );
          setTimeout(() => { }, 1000);
        }
      );
  }

  // Assessor multiselect
  filterAssessor(search: string): any {
    return this.searchedAssessor.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessor(event: MatChipInputEvent): void {
    if (!this.assessorAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.assessorDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
      this.updateSectionLastEdited('Assessment');
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      let sameValueRow = this.assessorDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.assessorDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
    }
    this.assessorInput.nativeElement.value = '';
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
    this.updateSectionLastEdited('Assessment');
  }

  removeAssessor(status: string): void {
    const index = (this.assessorDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Assessment');
    }
  }

  // Assessor Delegate multiselect
  filterAssessorDelegate(search: string): any {
    return this.searchedAssessorDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessorDelegate(event: MatChipInputEvent): void {
    if (!this.assessorDelAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.assessorDelDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.assessorDelDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchAssessorDelCntrl.setValue(null);
      this.updateSectionLastEdited('Assessment');
    }
  }

  selectedAssessorDelegateEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDelDD) {
      let sameValueRow = this.assessorDelDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.assessorDelDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDelDD = [];
      this.assessorDelDD.push(event.option.viewValue);
    }
    this.assessorDelInput.nativeElement.value = '';
    this.searchAssessorDelCntrl.setValue(null);
    this.searchAssessorDelCntrl.disable();
    this.searchAssessorDelCntrl.enable();
    this.updateSectionLastEdited('Assessment');
  }

  removeAssessorDelegate(status: string): void {
    const index = (this.assessorDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDelDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Assessment');
    }
  }

  // Reviewer multiselect
  filterReviewer(search: string): any {
    return this.searchedReviewer.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewer(event: MatChipInputEvent): void {
    if (!this.reviewerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.reviewerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.reviewerDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchReviewerCntrl.setValue(null);
      this.updateSectionLastEdited('Review');
    }
  }

  selectedReviewerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDD) {
      let sameValueRow = this.reviewerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.reviewerDD.push(event.option.viewValue);
      }
    } else {
      this.reviewerDD = [];
      this.reviewerDD.push(event.option.viewValue);
    }
    this.reviewerInput.nativeElement.value = '';
    this.searchReviewerCntrl.setValue(null);
    this.searchReviewerCntrl.disable();
    this.searchReviewerCntrl.enable();
    this.updateSectionLastEdited('Review');
  }

  removeReviewer(status: string): void {
    const index = (this.reviewerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Review');
    }
  }

  // Reviewer Delegate multiselect
  filterReviewerDelegate(search: string): any {
    return this.searchedReviewerDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewerDelegate(event: MatChipInputEvent): void {
    if (!this.reviewerDelAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.reviewerDelDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.reviewerDelDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchReviewerDelCntrl.setValue(null);
      this.updateSectionLastEdited('Review');
    }
  }

  selectedReviewerDelegateEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDelDD) {
      let sameValueRow = this.reviewerDelDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.reviewerDelDD.push(event.option.viewValue);
      }
    } else {
      this.reviewerDelDD = [];
      this.reviewerDelDD.push(event.option.viewValue);
    }
    this.reviewerDelInput.nativeElement.value = '';
    this.searchReviewerDelCntrl.setValue(null);
    this.searchReviewerDelCntrl.disable();
    this.searchReviewerDelCntrl.enable();
    this.updateSectionLastEdited('Review');
  }

  removeReviewerDelegate(status: string): void {
    const index = (this.reviewerDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDelDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Review');
    }
  }

  // Action Owner multiselect
  filterActionOwner(search: string): any {
    return this.searchedActOwner.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addActionOwner(event: MatChipInputEvent): void {
    if (!this.actOwnerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.actOwnerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.actOwnerDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchActOwnerCntrl.setValue(null);
      this.updateSectionLastEdited('Gap');
    }
  }

  selectedActionOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.actOwnerDD) {
      let sameValueRow = this.actOwnerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.actOwnerDD.push(event.option.viewValue);
      }
    } else {
      this.actOwnerDD = [];
      this.actOwnerDD.push(event.option.viewValue);
    }
    this.actOwnerInput.nativeElement.value = '';
    this.searchActOwnerCntrl.setValue(null);
    this.searchActOwnerCntrl.disable();
    this.searchActOwnerCntrl.enable();
    this.updateSectionLastEdited('Gap');
  }

  removeActionOwner(status: string): void {
    const index = (this.actOwnerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.actOwnerDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Gap');
    }
  }

  // Enhancement Action Owner multiselect
  filterEnhmtActionOwner(search: string): any {
    return this.searchedEnhmtActOwner.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addEnhmtActionOwner(event: MatChipInputEvent): void {
    if (!this.enhmtActOwnerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.enhmtActOwnerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.enhmtActOwnerDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchEnhmtActOwnerCntrl.setValue(null);
      this.updateSectionLastEdited('Enhancement');
    }
  }

  selectedEnhmtActionOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.enhmtActOwnerDD) {
      let sameValueRow = this.enhmtActOwnerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.enhmtActOwnerDD.push(event.option.viewValue);
      }
    } else {
      this.enhmtActOwnerDD = [];
      this.enhmtActOwnerDD.push(event.option.viewValue);
    }
    this.enhmtActOwnerInput.nativeElement.value = '';
    this.searchEnhmtActOwnerCntrl.setValue(null);
    this.searchEnhmtActOwnerCntrl.disable();
    this.searchEnhmtActOwnerCntrl.enable();
    this.updateSectionLastEdited('Enhancement');
  }

  removeEnhmtActionOwner(status: string): void {
    const index = (this.enhmtActOwnerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.enhmtActOwnerDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Enhancement');
    }
  }

  downloadDocument(
    id: number,
    fileName: string,
    extension: string,
    fileType: string
  ): void {
    if (fileType === 'Assessment') {
      this.isAssessmentLoader = true;
    } else {
      this.isReviewLoader = true;
    }
    this.gdprService.downloadEvidence(id).subscribe(
      (data: any) => {
        if (fileType === 'Assessment') {
          this.isAssessmentLoader = false;
        } else {
          this.isReviewLoader = false;
        }
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      }
    );
  }

  updateSectionLastEdited(filter: string): void {
    switch (filter) {
      case 'Assessment':
        this.isAssessmentLastEdited = true;
        break;
      case 'Review':
        this.isReviewLastEdited = true;
        break;
      case 'Gap':
        this.isGapActionLastEdited = true;
        break;
      case 'Enhancement':
        this.isEnhancementLastEdited = true;
        break;
      case 'OverallStatus':
        this.isReviewLastEdited = true;
    }
  }

  checkIfEdited(filter: string): void {
    switch (filter) {
      case 'AssessmentStatus':
        this.isAssessmentLastEdited = true;
        this.updateSADetails.isAssessmentStatusEdited = true;
        break;
      case 'ReviewStatus':
        this.isReviewLastEdited = true;
        this.updateSADetails.isReviewStatusEdited = true;
        break;
      case 'OverallStatus':
        this.updateSADetails.isOverallStatusEdited = true;
        break;
      case 'RuleConclusion':
        this.updateSADetails.isRuleConclusionEdited = true;
        break;
      case 'GapReviewStatus':
        this.isGapActionLastEdited = true;
        this.updateSADetails.isGapReviewStatusEdited = true;
        break;
      case 'GapActionStatus':
        this.isGapActionLastEdited = true;
        this.updateSADetails.isGapActionStatusEdited = true;
        break;
      case 'EnhancementReviewStatus':
        this.isEnhancementLastEdited = true;
        this.updateSADetails.isEnhancementReviewStatusEdited = true;
        break;
      case 'EnhancementActionStatus':
        this.isEnhancementLastEdited = true;
        this.updateSADetails.isEnhancementActionStatusEdited = true;
        break;
    }
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  addOwner(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.ownerAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.ownerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.ownerDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchOwnerCntrl.setValue(null);
    }
  }

  selectedOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.ownerDD) {
      let sameValueRow = this.ownerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.ownerDD.push(event.option.viewValue);
      }
    } else {
      this.ownerDD = [];
      this.ownerDD.push(event.option.viewValue);
    }
    if (this.ownerInput) {
      this.ownerInput.nativeElement.value = '';
    }
    this.searchOwnerCntrl.setValue(null);
    this.searchOwnerCntrl.disable();
    this.searchOwnerCntrl.enable();
  }

  getOwnerDD() {
    this.regulationService
      .getUserListForOwner()
      .subscribe((res: Array<FilterViewModelForOwner>) => {
        // this.searchedOwner = res;
        this.allSearchedOwner = res;
        // this.searchOwnerCntrl.valueChanges.subscribe((term: any) => {
        //   this.searchedOwner = term ? this.filterOwner(term) : res;
        // });
      });
  }
  removeOwner(status: string): void {
    const index = (this.ownerDD as string[]).indexOf(status);
    if (index >= 0) {
      (this.ownerDD as string[]).splice(index, 1);
    }
  }

  fetchSelfAssessmentAllDropdownList(): void {
    this.isLoadingDD = true;
    this.gdprService
      .getSelfAssessmentAllDropdownList()
      .subscribe((result: SelfAssessmentAllDropdownList) => {
        this.isLoadingDD = false;
        this.selfAssessmentAllDropdownList = result;
        this.assessmentStatus =
          this.selfAssessmentAllDropdownList.assessmentStatus;
        this.reviewStatus = this.selfAssessmentAllDropdownList.reviewStatus;
        this.overallStatus = this.selfAssessmentAllDropdownList.overallStatus;
        this.ruleConclusion = this.selfAssessmentAllDropdownList.ruleConclusion;
        this.gapReviewStatus =
          this.selfAssessmentAllDropdownList.gapReviewStatus;
        this.actionStatus = this.selfAssessmentAllDropdownList.actionStatus;
        this.enhancementReviewStatus =
          this.selfAssessmentAllDropdownList.enhancementReviewStatus;
        this.enhancementActionStatus =
          this.selfAssessmentAllDropdownList.enhancementActionStatus;
      });
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
  openView(id: number, detailType: number) {
    const dialogRef = this.dialog.open(ChangeDetailComponent, {
      width: '1800px',
      height: '870px',
      data: {
        id: id,
        detailType: detailType,
        ruleArr: null,
        filterType: 'All',
        type: 'modal',
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      // this.ruleBookViewCloseData = result;
      // if (result) {
      //   const index = this.ruleBooks.data.findIndex(
      //     (item) => item.id === result.Id
      //   );
      //   if (index !== -1) {
      //     this.ruleBooks.data[index].applicable = result.IsApplicable;
      //     this.ruleBooks.data[index].operative = result.IsOperative;
      //     this.ruleBooks.data[index].isRead = result.IsRead;
      //     this.ruleBooks.data[index].owner = result.ownerList;
      //   }
      // }
      // this.sessionService.isLibraryTabActive = false;
    });
  }
  //previous next button add
  checkSibling(id: number, type: string): boolean {
    const index = this.idList.findIndex((a) => Number(a)=== Number(id));
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.idList[index + 1] ? true : false;
      } else {
        return this.idList[index - 1] ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
    const index = this.idList.findIndex(
      (a) => Number(a) === Number(this.selfAssessmentId));
    if (type === 'Next') {
      this.selfAssessmentId = this.idList[index + 1];
    } else {
      this.selfAssessmentId = this.idList[index - 1];
    }
    this.redirectLink();
  }
  redirectLink() {
    let link = '/self-assessment/details/self/' + this.selfAssessmentId + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
}
